import * as React from 'react';
import { Question, MagnifyingGlass, VideoCamera, Envelope, FacebookLogo, InstagramLogo, ChatCircleDots, SecurityCamera } from "@phosphor-icons/react";
export const evidenceTypeValues = [undefined, 'body cam', 'cctv', 'email', 'facebook post', 'instagram', 'signal', 'other'];
const evidenceTypeIcons: Record<string, React.ReactNode> = {
  'body cam': <VideoCamera size={16} />,
  'cctv': <SecurityCamera size={16} />,
  'email': <Envelope size={16} />,
  'facebook post': <FacebookLogo size={16} />,
  'instagram': <InstagramLogo size={16} />,
  'signal': <ChatCircleDots size={16} />,
  'other': <MagnifyingGlass size={16} />
};
const EvidenceTypes = React.memo((props: {
  value: string;
}) => <div aria-label="Evidence Type" className="flex justify-left items-center">
    {evidenceTypeIcons[props.value] || <Question size={16} />}&nbsp;&nbsp;{props.value}
  </div>);
EvidenceTypes.displayName = 'EvidenceTypes';
export default EvidenceTypes;